import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatPaginator } from '@angular/material';
import { ObservableMedia, MediaChange } from '@angular/flex-layout';

import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { map } from 'rxjs/operators/map';
import { merge } from 'rxjs/observable/merge';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators/takeUntil';

import { DataTableSource } from '../../../classes/DataTableSource/datatablesource';

import { CourseChoice } from '../../application/application.service';

@Component({
    selector: 'dialog-fullschedule-component',
    styleUrls: ['fullschedule.dialogcomponent.css'],
    templateUrl: 'fullschedule.dialogcomponent.html',
})
export class FullScheduleDialogComponent implements OnInit, OnDestroy {
    @ViewChild(MatPaginator) paginator: MatPaginator;

    private _subrelease: Subject<void> = new Subject<void>();

    AllHeaders: string[] = ['Course', 'Name', 'ReferenceNum', 'CountyTaught'];
    canceltext: string;
    LastSizeCode: string;
    message: string;
    oktext: string;
    SmallDisplay: boolean;
    title: string;
    Courses: CourseChoice[];
    CourseData: DataTableSource<CourseChoice>;
    ReadyStatus: ChangesInfo;
    VisibleHeaders: string[];
    VisibleColumns: string[];

    constructor(
        public dialogRef: MatDialogRef<FullScheduleDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data: BaseFullScheduleDialogOptions,
        private mediaChange: ObservableMedia
    ) {
        this.canceltext = data.CancelText || 'Cancel';
        this.message = data.MessageText || '';
        this.oktext = data.OKText || 'Run Report';
        this.title = data.TitleText || 'Choose Report Options';

        this.Courses = data.Courses && data.Courses.length ? <CourseChoice[]>JSON.parse(JSON.stringify(data.Courses)) : [];
    }

    ngOnDestroy() {
        this._subrelease.next();
        this._subrelease.complete();
    }

    ngOnInit() {
        const self = this;

        self.CourseData = new DataTableSource<CourseChoice>(self.Courses, self.paginator);
        self.ReadyStatus = { LastCheck: null, Ready: true };

        self.LastSizeCode = self.mediaChange.isActive('xs')
            ? 'xs'
            : self.mediaChange.isActive('sm')
            ? 'sm'
            : self.mediaChange.isActive('md')
            ? 'md'
            : self.mediaChange.isActive('lg')
            ? 'lg'
            : 'xl';
        self.SmallDisplay = self.LastSizeCode === 'xs' || self.LastSizeCode === 'sm';
        self.VisibleHeaders = self.SmallDisplay ? ['SmallDisplay'] : self.AllHeaders.slice();
        self.VisibleColumns = self.Courses && self.Courses.length ? self.VisibleHeaders.slice() : ['NoData'];

        self.mediaChange
            .asObservable()
            .pipe(takeUntil(self._subrelease))
            .subscribe(media => {
                self.SmallDisplay = media.mqAlias === 'xs' || media.mqAlias === 'sm';
                self.LastSizeCode = media.mqAlias;
                self.VisibleHeaders = self.SmallDisplay ? ['SmallDisplay'] : self.AllHeaders.slice();
                self.VisibleColumns = self.Courses && self.Courses.length ? self.VisibleHeaders.slice() : ['NoData'];
            });

        // Trigger an initial status check
        self.CheckForChanges();
    }

    // #region Cancel Handler Method

    CancelHandler() {
        this.dialogRef.close(null);
    }

    // #endregion

    // #region OK Handler Method

    OkHandler() {
        this.dialogRef.close(this.CourseData.data);
    }

    // #endregion

    // #region Check For Changes Method

    CheckForChanges() {
        // Check to see if everything is valid.
        let isValid = true;

        if (this.CourseData.data) {
            const current = JSON.stringify(this.CourseData.data);

            if (current !== this.ReadyStatus.LastCheck) {
                // Difference detected. Check for safety.
                this.CourseData.data.every(item => {
                    if (!item.ReferenceNumber && !item.CountyTaught) {
                        isValid = false;
                    }
                    if (!isValid) {
                        return false;
                    } // Stop looping.
                    return true; // Keep looping.
                });

                const update: ChangesInfo = {
                    LastCheck: current,
                    Ready: isValid,
                };

                this.ReadyStatus = update; // Triggers another ngDoCheck cycle.
            }
        }
    }

    // #endregion
}

// #region Custom Classes

// #region Changes Info Class

export class ChangesInfo {
    LastCheck: string;
    Ready: boolean;
}

// #endregion

// #region Full Schedule Dialog Options Class

export class BaseFullScheduleDialogOptions {
    TitleText?: string;
    MessageText?: string;
    OKText?: string;
    CancelText?: string;
    IconColor?: string;
    IconName?: string;
    ShowIcon?: boolean;
    height?: string;
    width?: string;
    Courses?: CourseChoice[];
}

// #endregion

// #endregion



// WEBPACK FOOTER //
// ./src/services/dialogs/fullschedule/fullschedule.dialogcomponent.ts